export const JobPostingApplicantIndex = 'job-posting-applicant-index';
export const PipelineShow = 'pipeline-show';

export type PageContext = 'index' | 'funnel' | typeof PipelineShow | typeof JobPostingApplicantIndex;
